<template>
  <div class="rates-display">
    <div class="container-fluid rates-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="background">
            <div class="text-center why-gsc" v-if="whyGsc">
              <h2>Find Out More About GreenShareCar</h2>
              <a v-link="{ path: '/why-gsc' }" class="btn btn-success btn-lg">Why GreenShareCar? </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="header-bar">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">Rates</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <template v-for="(index, accountType) in accountTypes">
          <div class="col-md-2 col-sm-4 col-xs-12" v-bind:class="{ 'col-md-offset-1': index === 0 }">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h2 class="panel-title">{{ accountType.name }}</h2>
              </div>
              <h2 class="panel-sub-heading">{{ accountType.description }}</h2>
              <div class="panel-body">
                <div v-if="accountType.annualFee" class="price-block price-block-center">
                  <span class="price-block-dollar">$</span>
                  <span class="price-block-price">{{ accountType.annualFee | currency_short }}</span>
                  <span class="price-block-per">/yr</span>
                </div>
                <div v-if="accountType.monthlyFee" class="price-block price-block-center">
                  <span class="price-block-dollar">$</span>
                  <span class="price-block-price">{{ accountType.monthlyFee | currency_short }}</span>
                  <span class="price-block-per">/mo</span>
                </div>
                <p v-if="accountType.monthlyFee" class="price-info text-center">Billed biannually</p>
                <p v-if="!accountType.businessPlan && !accountType.monthlyFee" class="price-info">&nbsp;</p>
                <p v-if="accountType.businessPlan" class="price-info text-center">$55 setup fee</p>
                <p v-if="!accountType.driverCost" class="joining-fee">No joining fee</p>
                <p v-else class="joining-fee">
                  ${{ accountType.driverCost | currency_short }} per driver
                </p>
                <p v-else class="joining-fee-info">&nbsp;</p>
                <h4 class="vehicle-heading">Vehicles</h4>
                <hr/>
                <template v-for="rate in accountType.Rates | orderBy hourlyRate">
                  <template v-if="!rate.CarTypeUuid">
                    <h5 class="hire-heading">{{ rate.CarClass.name }}</h5>
                    <div class="small-price-block text-center">
                      <label class="text-normal">
                        <span class="small-price-block-dollar">$</span>
                        <span class="small-price-block-price">{{ rate.hourlyRate }}</span>
                        <span class="small-price-block-per label-margin">/hr</span>
                      </label>
                      <span class="label-margin">-</span>
                      <label class="text-normal">
                        <span class="small-price-block-dollar">$</span>
                        <span class="small-price-block-price">{{ rate.dailyRate }}</span>
                        <span class="small-price-block-per">/day</span>
                      </label>
                    </div>
                    <br/>
                  </template>
                </template>
                <p class="rate-info">All day bookings include {{ accountType.Rates[1].includeKms }}km</p>
                <h5 class="hire-heading">
                  <i class="fa fa-2x fa-plus-circle"></i><br/><br/>
                  Kilometers
                </h5>
                <div class="small-price-block text-center">
                  <span class="small-price-block-dollar">$</span>
                  <span class="small-price-block-price">{{ accountType.Rates[1].perKmCost }}</span>
                  <span class="small-price-block-per">/km</span>
                </div>
                <hr/>
                <h5 class="hire-heading">
                  Unlimited Kilometer Option
                </h5>
                <div class="small-price-block text-center">
                  <label class="text-normal">
                    <span class="small-price-block-dollar">$</span>
                    <span class="small-price-block-price">3.75</span>
                    <span class="small-price-block-per label-margin">/hr</span>
                  </label>
                  <span class="label-margin">-</span>
                  <label class="text-normal">
                    <span class="small-price-block-dollar">$</span>
                    <span class="small-price-block-price">22</span>
                    <span class="small-price-block-per">/day</span>
                  </label>
                  <div>Within Victoria Only</div>
                </div>
                <hr/>
                <div class="drivers">
                  <h5 class="hire-heading">Drivers</h5>
                  <span v-for="n in accountType.maxAccounts">
                    <i class="fa fa-user"></i>
                  </span>
                  <i v-if="accountType.businessPlan" class="fa fa-plus"></i>
                </div>
                <hr/>
                <div v-if="accountType.businessPlan">
                  <p class="pre-authorisation">$0<br/>Pre-authorisation*</p>
                </div>
                <div v-else>
                  <p class="pre-authorisation">${{ accountType.preAuth | currency_short }}<br/>Pre-authorisation</p>
                </div>
              </div>
              <div class="panel-footer text-center">
                <hr/>
                <button class="btn btn-default" @click="register(accountType.permalink)">Join</button>
              </div>
            </div>
            <p class="joining-fee-info" v-if="accountType.businessPlan">* ${{ accountType.preAuth | currency_short }} Pre-authorisation for less than 4 drivers</p>
          </div>
        </template>
      </div>
      <div class="row">
        <h2>The Fine Print</h2>
        <h4 class="fine-print-heading">Fuel &amp; Insurance Included</h4>

        <p>Some of the biggest costs of owning a vehicle are fuel and insurance.
           We include both with every booking!</p>

        <h4 class="fine-print-heading">Included Distance</h4>

        <p>We include 150 kilometres of distance on every
          <strong>all-day-booking</strong>. For bookings more than 24 hours, we
          include 150km for every 24 hours. If your booking is less than the
          daily rate, each kilometre travelled will be billed at $0.39.</p>

        <h4 class="fine-print-heading">Six Month Membership</h4>

        <p>Membership on the Economy and Everyday plans is for a six month term.
           Six months' membership fees are charged upfront when you join.</p>

        <h4 class="fine-print-heading">Optional Insurance (Additional Coverage)
        </h4>

        <p>The insurance excess for damage to GreenShareCar vehicles starts at
          $1,500. Higher excesses apply to young drivers, certain vehicle types
          and foreign license holders (See
          <a :href="$root.muaUrl" target="_blank">
          Member User Agreement</a> for details). Remember you can be
          responsible for damage from 'bad luck' like having a tree fall on the
          car. We provide you the option of reducing that excess by 80% for
          $1.95 per hour up to a maximum of $19.95 per day.</p>

        <h4 class="fine-print-heading">Pre-authorisation*</h4>

        <p>A pre-authorisation is a temporary hold on your credit card. The
          funds are held by your bank for 7 days when you make a booking, and
          released back into your account if you don't make any further
          bookings.</p>

        <h4 class="fine-print-heading">Business Pre-authorisation*</h4>

        <p>Businesses with less than 4 Drivers can still use GSC at business
          rates, however a $500 credit card preauthorisation applies with
          bookings. This pre-authorisation is held by your bank for 7 days,
          and is released if you don't make another booking.</p>

        <h4 class="fine-print-heading">Review Your Booking &amp; Drive </h4>

        <p>We try and assist our members by publishing all our hire rates
          online but the correct billing amount will always be quoted to you
          upon each reservation, with no fine print. We recommend that you
          print a copy of the reservation confirmation and retain it for your
          records.</p>

        <h4 class="fine-print-heading">Parking Levy</h4>

        <p>Some parking bays incur a location surcharge. This is listed when
          you choose a car and before you make a booking.</p>

        <h4 class="fine-print-heading">Annual Membership Fee</h4>

        <p>Membership on the Casual plan is subject to an annual fee. $55 will
          be deducted at the time of joining and recharged on the anniversary
          of your joining date each year.  If you are no longer a student after
          the initial year then your account will be switched to a casual
          membership. </p>

        <h4 class="fine-print-heading">After Hours Service (24 Hours)</h4>

        <p>GreenShareCar offers a 24 hours service for members that require
          assistance outside of business hours (9am-5pm Monday to Friday).
          Please call 1300 575 878 for after hours service. </p>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatesDisplay',
  components: {
  },
  data () {
    return {
      accountTypes: [],
      whyGsc: false
    }
  },
  ready () {
    let authType = 'public'
    this.$http.get(`${authType}/account-type-rates`, {}).then((response, status, request) => {
      this.accountTypes = response.data.accountTypes
      this.whyGsc = response.data.whyGsc
    })
  },
  route: {
    data () {
    }
  },
  methods: {
    register (accountType) {
      this.$http.headers.common.Authorization = false
      window.sessionStorage.removeItem('token')
      this.$route.router.go(`/sign-up/register/${accountType}`)
    }
  }
}
  </script>



// WEBPACK FOOTER //
// RatesDisplay.vue?4ef6efb6